import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { SubparametroResultadosRadiacionModal } from "./SubparametroResultadosRadiacionModal";

class CadenaRadiacionPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1"
    }
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    })
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () => pageApi.getComponent('gridDetalleMuestreo');
    const { TabPane } = Tabs;

    const ConfiguracionModalConfig = (data) => {
      const { showModal } = this.context;
      let obj = {};
      obj = { ...obj, data };

      showModal({
        width: 800,
        maskClosable: false,
        component: <SubparametroResultadosRadiacionModal name={obj} getParentApi={pageApi.getApi} />
      });
    };

    const formDetalleMuestreo = (pageApi) => ({
      title: 'Condiciones Ambientales',
      layout: 'vertical',
      autoLoad: true,
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: (resp) => {
        }
      },
      save: {
        queryId: 349,
        hideMessage: true,
        hideMessageError: true,
      },
      update: {
        queryId: 357,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: 'nom_estacion', label: 'Estación', column: 4, readOnly: true },
        { name: 'desc_estacion', label: 'Descripción', column: 4, readOnly: true },
        { name: 'geo_estacion', label: 'Georeferencia', column: 4, readOnly: true },
        { name: 'alt_estacion', label: 'Altitud', column: 4, readOnly: true },
        { name: 'zona_estacion', label: 'Zona', column: 4, readOnly: true },
      ],
    })

    const gridDetalleMuestreo = (pageApi) => ({
      title: '4. Detalle de muestreo',
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: 'ID_PARAMETRO',
      load: {
        queryId: 938,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
            id_doc: pageApi.name.id_ss
          }
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 932,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "MUESTRA", label: "Cod. Muestra" },
        { name: "tipo_ensayo", label: "Método" },
        { name: "estacion", label: "Estación" },
        { name: "descripcion", label: "Descripción" },
        {
          type: 'date',
          name: "FECHA_INICIAL",
          label: "Fecha Inicio",
          //      onClick: (value, row) => {  
          // if(row?.Esbloqueo_supervisor_OMA === 1){
          // getGrid().getConfig().fields[5].editable = false; 
          // }
          // else{
          // getGrid().getConfig().fields[5].editable = true;   
          // } 
          // },  
          editable: true,
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: 'date',
          name: "HORA_INICIAL",
          label: "Hora Inicio",
          //      onClick: (value, row) => {  
          // if(row?.Esbloqueo_supervisor_OMA === 1){
          // getGrid().getConfig().fields[6].editable = false; 
          // }
          // else{
          // getGrid().getConfig().fields[6].editable = true;   
          // } 
          // },  
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm
        },
        {
          type: 'date',
          name: "FECHA_FIN",
          label: "Fecha Fin",
          //      onClick: (value, row) => {  
          // if(row?.Esbloqueo_supervisor_OMA === 1){
          // getGrid().getConfig().fields[7].editable = false; 
          // }
          // else{
          // getGrid().getConfig().fields[7].editable = true;   
          // } 
          // },  
          editable: true,
          format: 'DD/MM/YYYY',
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: 'date',
          name: "HORA_FIN",
          label: "Hora Fin",
          //      onClick: (value, row) => {  
          // if(row?.Esbloqueo_supervisor_OMA === 1){
          // getGrid().getConfig().fields[8].editable = false; 
          // }
          // else{
          // getGrid().getConfig().fields[8].editable = true;   
          // } 
          // },  
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm
        },
        { name: 'georeferencia', label: 'Ubicación Geográfica' },
        { name: 'temp_ambiental_promedio', label: 'Temperatura ambiental promedio (C°)', type: 'number', editable: true },
        { name: 'humedad_relativa_promedio', label: 'Humedad relativa promedio (%)', type: 'number', editable: true },
        { name: 'tipo_sistema_electrico', label: 'Tipo de sistema eléctrico', type: 'text', editable: true },
        { name: 'alturas_recpecto_suelo', label: 'Alturas con respecto al suelo (m)', type: 'number', editable: true },
        { name: 'distancia_horizontal', label: 'Distancia Horizontal (m)', type: 'number', editable: true },
        {
          ...COLUMN_DEFAULT.CHECK, label: 'Opciones', title: 'Ingresar Resultados', onClick: (value, row) => {
            ConfiguracionModalConfig(row);
          }
        },
        {
          ...COLUMN_DEFAULT.ADD,
          label: "Replicar",
          color: "red",
          column: 12,
          onClick: async (value, row, index) => {
            await getgrid_detalle_muestreo().saveItemEditing();
            await getgrid_detalle_muestreo().refresh();
            const replicar = getgrid_detalle_muestreo()
              .getData()
              .map((data) => {
                data.fecha_prevista_muestreo = row.fecha_prevista_muestreo;
                data.hora_inicio_muestreo = row.hora_inicio_muestreo;
                data.zonificacion = row.zonificacion;
                data.fuente_ruido = row.fuente_ruido;
                data.tiempo_medicion = row.tiempo_medicion;
                return data;
              });
            getgrid_detalle_muestreo().setData(replicar);
          },
        }
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "formDetalleMuestreo",
        config: formDetalleMuestreo(pageApi),
        type: 'form'
      },
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: 'grid'
      },
    ];

    return (
      <StickyContainer>
        <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Datos del Servicio" key="2" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DatosServisiosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Procedencia de la muestra" key="3" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <ProcedenciaMuestraModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Detalle del muestreo" key="4" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DetalleMuestreoModal api={pageApi} data={{ ...pageApi.name }} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} gridsConfig={gridsConfigDetalleMuestreo} />
          </TabPane>

          <TabPane tab="Equipos Utilizados" key="5" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <EquiposUtilizadosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Otros Datos" key="6" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <OtrosDatosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>
        </Tabs>
      </StickyContainer >
    );
  }
}

export default withRouter(CadenaRadiacionPage);